import { _ } from "libs";
import React from "react";
import { Form, Field } from "react-final-form";
import { Profile, PrivacySettingKeys, PrivacySettingValues, NotificationSettingsArray } from "../../types";
import arrayMutators from "final-form-arrays";

type Props = {
	onChange: (privacySettings: Profile["privacySettings"]) => void;
	profile: Profile;
};

function mapPrivacySettings(privacySettings: Profile["privacySettings"]) {
	const result = {};

	Object.values(PrivacySettingKeys).forEach((key: PrivacySettingKeys) => {
		if (privacySettings[key]) {
			result[key] = privacySettings[key];
		} else {
			result[key] = PrivacySettingValues.CLUB_AND_BUDDIES;
		}
	});

	return result;
}

export function PrivacyForm({ onChange, profile }: Props) {
	const privacySettings = mapPrivacySettings(profile.privacySettings);

	return (
		<Form
			onSubmit={(values) => {
				const privacySettings = values as Record<any, any>;
				onChange(privacySettings);
			}}
			mutators={{
				...arrayMutators,
			}}
			initialValues={{ ...privacySettings }}
			render={({ handleSubmit, submitting, invalid, values }) => (
				<form onSubmit={handleSubmit} className="fullWidth" key="privacySettingsForm">
					{Object.values(PrivacySettingKeys).map((key) => {
						return (
							<>
								<h5>{_(`privacyForm.${key}.title`)}</h5>
								<fieldset className="radioGroup" id={key}>
								{Object.values(PrivacySettingValues).map((value) => {
									let id = key + "-" + value;
									return (
										<div className="field radio" key={id}>
											<Field
												id={id}
												name={key}
												type="radio"
												component="input"
												value={value}
												checked={values[key] === value}
											/>
											<label htmlFor={id}>{_(`privacyForm.${value}.label`)}</label>
										</div>
									);
								})}
								</fieldset>
								<div className="note">{_(`privacyForm.${key}.description`)}</div>
							</>
						);
					})}
					<div className="buttons">
						<button type="submit" className="button" disabled={submitting || invalid}>
							{_("saveBtn")}
						</button>
					</div>
				</form>
			)}
		/>
	);
}

export default PrivacyForm;
